import csm from "redux-saga";

let sagaMiddleware;

export const creteSagaMiddleware = (...props) =>
  (sagaMiddleware = csm(...props));

export const runSaga = (saga) => {
  if (sagaMiddleware) {
    sagaMiddleware.run(saga);
  }
};
